import HorizontalProfileQRCard from '@UI/ProfileQRCard/HorizontalProfileQRCard'
import Modal from '../Modal'
import { BodyEdit } from './BodyEdit/BodyEdit'
import { BodyModal } from './BodyModal/BodyModal'
import { BodyPersonal } from './BodyPersonal/BodyPersonal'
import ButtonActive from './ButtonActive/ButtonActive'
import { Header } from './Header/Header'
import s from './ProfileCard.module.css'
import cn from 'classnames'
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'
import ProfileHistory from './ProfileHistory'

export const ProfileCard = (props) => {
  const viewer = useSelector(selectProfile)
  return (
    <>
      <div
        className={cn(s.card, {
          [s.employeePersonalCard]:
            props.settingCard.type === 'personal' && props.isEmployee,
        })}
      >
        <Header {...props} />
        {props.settingCard.type === 'personal' ? (
          <BodyPersonal {...props} />
        ) : (
          <BodyEdit {...props} />
        )}
        <HorizontalProfileQRCard
          user={props?.user}
          style={{ maxWidth: '400px' }}
        />
        {!props.hideEditMode &&
          !(props.settingCard.type === 'personal' && props.isEmployee) && (
            <ButtonActive {...props} />
          )}
      </div>
      {viewer.role === 'admin' && props.user?.id && props.user?.rolesName?.includes('children') && (
        <ProfileHistory userId={props.user.id} />
      )}
      <Modal active={props.modalOptions.active} setActive={props.closeModal}>
        <BodyModal {...props.modalOptions} />
      </Modal>
    </>
  )
}
